import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfilePictureComponent } from './components/profile-picture/profile-picture.component';
import { SharedUiIconsModule } from '@shared/ui/icons';
import { SharedUtilsDisableImageCachingModule } from '@shared/utils/disable-image-caching';

@NgModule({
  imports: [CommonModule, SharedUiIconsModule, SharedUtilsDisableImageCachingModule],
  declarations: [ProfilePictureComponent],
  exports: [ProfilePictureComponent],
})
export class SharedUiProfilePictureModule {}
